import Color from 'colorjs.io'

/**
 * 
 * @param {String} variableName
 * @param {String} [space='oklch'] - Expected color space, one of 'hex', 'oklch'
 * @returns {Color}
 */
export const getComputedCssVariableValue = (variableName, space = 'oklch') => {
    
    // eslint-disable-next-line no-restricted-globals
    const el = document.querySelector('body')
    
    if (!el)
        throw new Error('Body element not found')
    
    const value = getComputedStyle(el)
        .getPropertyValue(variableName)
        .trim()
    
    switch (space) {
        case 'hex': return new Color(`#${value}`)
        case 'oklch': return new Color(`oklch(${value})`)
        default: throw new Error(`Invalid color space "${space}"`)
    }
    
}
